<template>
  <dy-item-wrap :item="item">
    <el-input
      v-bind="$attrs"
      v-on="$listeners"
      clearable
      :type="item.subtype"
      :placeholder="item.placeholder"
      :disabled="item.disabled"
      @keyup.enter.native="keyEvent"
    />
  </dy-item-wrap>
</template>

<script>
import Emitter from "element-ui/src/mixins/emitter";
import DyFormMixin from "../dyformitemMixin";
export default {
  mixins: [DyFormMixin, Emitter],
  methods:{
    keyEvent(e){
      this.dispatch("sf", "keyup-enter", this);
    }
  }
};
</script>




// WEBPACK FOOTER //
// StringWidget.vue?012223d6